/**
 * @param {Promise<Response>} response 
 */
export async function HandleResponseJson(response) {
    if (response.status === 204) return '';
    return response.json();
}